import app_2 from '@/public/features/recurring_jobs/App_2.webp';
import bg from '@/public/features/recurring_jobs/Main.webp';

const intro = {
  tag: '',
  description: `Optimize your business efficiency by scheduling and managing recurring jobs effortlessly. Ideal for maintenance and service plans, our system ensures smooth operations and consistent service delivery.`,
  imageSrc: bg.src,
  image: bg,
  first_title: 'Streamline Your Operations',
  second_title: ' with\xa0Our Recurring Jobs Feature',
};

const blog = {
  title: 'Our Blog',
  description: `Dive into a wealth of insights tailored to your industry with Orcatec's blog, your go-to resource 
for the latest trends and tips in service scheduling software free`,
};

const bookDemo = {
  title: `Book a Free Demo`,
  description: `Book a free demo to unlock the full potential of our software for HVAC contractors! Orcatec team is here to guide you. Fill out the form below to receive expert consultation. Don’t miss this opportunity to transform your HVAC business with Orcatec's cutting-edge solutions, specially designed for HVAC contractors!`,
};

const fullArticle2 = {
  image: {
    path: app_2,
    alt: `What are Recurring Jobs?`,
  },
  title: `What are Recurring Jobs?`,
  description: `A recurring jobs feature allows you to schedule and manage repetitive tasks automatically. This is essential for businesses that offer regular maintenance or service plans, ensuring you never miss an appointment and always stay on top of your commitments.`,
  item: [
    {
      title: 'Customizable intervals',
      description:
        'Set individual parameters for recurring intervals to match your specific needs. Whether it’s daily, weekly, monthly, or annually, our system allows you to customize the frequency of each recurring job.',
    },
    {
      title: 'Perfect for maintenance plans',
      description:
        'Ideal for maintenance and service plans, our recurring jobs feature ensures that all scheduled services are automatically planned and tracked, enhancing your service reliability and customer satisfaction.',
    },

    {
      title: 'Intelligent dispatching',
      description: `Our system intelligently dispatches recurring jobs, optimizing your team's schedule and ensuring the right technician is assigned to the right job at the right time. This maximizes efficiency and improves overall productivity.`,
    },
  ],
};

export { blog, bookDemo, fullArticle2, intro };
